import { Injectable, effect, inject, signal } from '@angular/core';
import { MatomoTracker } from 'ngx-matomo-client';

import { CircleService } from '../services/circle.service';

@Injectable({
  providedIn: 'root',
})
export class MatomoService {
  private matomoTracker = inject(MatomoTracker);
  private circleService = inject(CircleService);
  private readyResolve!: () => void;
  public readyPromise = new Promise<void>(resolve => {
    this.readyResolve = resolve;
  });

  ready = signal(false);

  _ = effect(() => {
    const userInfo = this.circleService.userInfo();

    // Wait until CircleService.getUserInfo() has completed at least once.
    if (userInfo === undefined || this.ready()) {
      return;
    }

    // If user info is available, attach user context; otherwise proceed without it.
    if (userInfo?.email) {
      this.setUserId(userInfo.email);
      if (userInfo.department) {
        this.setUserDepartment(userInfo.department);
      }
    }
    this.markReady();
  });

  markReady = () => {
    if (this.ready()) {
      return;
    }
    this.ready.set(true);
    this.readyResolve();
  };

  trackEvent = async (category: string, action: string, name?: string, value?: number) => {
    await this.readyPromise;
    this.matomoTracker.trackEvent(category, action, name, value);
  };

  trackPageView = async (title?: string) => {
    await this.readyPromise;
    this.matomoTracker.trackPageView(title);
  };

  setCustomUrl = async (url: string) => {
    this.matomoTracker.setCustomUrl(url);
  };

  optUserOut = () => {
    this.matomoTracker.optUserOut();
  };

  forgetUserOptOut = () => {
    this.matomoTracker.forgetUserOptOut();
  };

  setUserId = (userId: string) => {
    this.matomoTracker.setUserId(userId);
  };

  setUserDepartment = (department: string) => {
    this.matomoTracker.setCustomDimension(1, department);
  };
}
